export default __webpack_public_path__ + "static/media/xlsx.a547559a.svg";